angular.module('modals')
    .controller('PatientModalController', ['$scope', '$uibModalInstance', 'Logger', 'Auth', 'ModalHandler', 'Patient', 'fullname', '$uibModal', 'Alert',
        function ($scope, $uibModalInstance, Logger, Auth, ModalHandler, Patient, fullname, $uibModal, Alert) {

            $scope.title = 'Create a New Patient Record';
            $scope.alerts = [];
            $scope.datepickerStatus = { opened: false };

            if (fullname) {
                var spacePosition = fullname.lastIndexOf(' '); //lastIndexOf is needed for names with several words, like Jean Francois Moullin, where Jean Francois is a name and Moullin is a surname
                var first_name = '';
                var last_name = '';
                if (fullname != '' && spacePosition == -1) {
                    first_name = fullname;
                } else {
                    first_name = fullname.substr(0, spacePosition);
                    last_name = fullname.substr(spacePosition + 1);
                }
                $scope.patient = { 'first_name': first_name, 'last_name': last_name };
            }

            $scope.ok = function (patient) {
                patient.practice_id = Auth.get() ? Auth.get().practice_id : '';
                patient.birthday = moment(patient.birthday).format('YYYY-MM-DD');//fix for #114475519
                function createPatient() {
                    Patient.save({ patient: patient },
                        function (success) {
                            ModalHandler.close($uibModalInstance, success);
                        },
                        function (failure) {
                            $scope.alerts = [];
                            Alert.error($scope.alerts, 'Error occurred during patient create.', true)
                        });
                };

                if (patient.practice_id) {
                    Patient.searchPatientDuplicate(patient,
                        function (success) {
                            if (success.patient) {
                                var dedupingModalInstance = $uibModal.open({
                                    templateUrl: 'partials/patient_deduping_form.html',
                                    controller: 'DedupingPatientModalController',
                                    resolve: {
                                        isCreatingPatient: function () {
                                            return true;
                                        }
                                    }
                                });

                                dedupingModalInstance.result.then(function (useExistingPatient) {
                                    if (useExistingPatient) {
                                        ModalHandler.close($uibModalInstance, success.patient);
                                    } else {
                                        createPatient();
                                    }
                                }).catch(function () {
                                    // Logger.log('Modal dismissed');
                                });
                            } else {
                                createPatient();
                            }
                        });
                } else {
                    ModalHandler.close($uibModalInstance, patient);
                }

            };
            $scope.openDatePicker = function ($event) {
                $scope.datepickerStatus.opened = true;
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);

            };
        }])

    .controller('DedupingPatientModalController', ['$scope', '$uibModalInstance', 'isCreatingPatient',
        function ($scope, $uibModalInstance, isCreatingPatient) {
            $scope.useExistingPatient = true;
            $scope.isCreatingPatient = isCreatingPatient;

            $scope.ok = function () {
                $uibModalInstance.close($scope.useExistingPatient);
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }])

    .controller('EditPatientModalController', ['$scope', '$state', '$uibModalInstance', 'Logger', 'Alert', 'ModalHandler', 'Patient', 'patientForEdit', '$uibModal',
        function ($scope, $state, $uibModalInstance, Logger, Alert, ModalHandler, Patient, patientForEdit, $uibModal) {
            $scope.title = 'Edit Patient Record';
            $scope.datepickerStatus = { opened: false };
            $scope.alerts = [];
            $scope.patient = { first_name: patientForEdit.first_name, last_name: patientForEdit.last_name, birthday: moment(patientForEdit.birthday).toDate(), email: patientForEdit.email, phone: patientForEdit.phone };//we need a copy of the object to be able to cancel changes (otherwise two-way binding changes the patient's data on parent page right away)
            $scope.ok = function (patient) {
                patient.birthday = moment(patient.birthday).format('YYYY-MM-DD');//fix for #114475519
                function updatePatient() {
                    Patient.update({ id: patientForEdit.id }, { patient: patient },
                        function (success) {
                            ModalHandler.close($uibModalInstance, success);
                        },
                        function (failure) {
                            $scope.alerts = [];
                            Alert.error($scope.alerts, 'Error occurred during patient update.', true);
                        });
                };

                patient.id = patientForEdit.id;
                patient.practice_id = patientForEdit.practice_id;

                if ($state.is('createReferral')) {
                    Patient.searchPatientDuplicate(patient,
                        function (success) {
                            if (success.patient) {
                                var dedupingModalInstance = $uibModal.open({
                                    templateUrl: 'partials/patient_deduping_form.html',
                                    controller: 'DedupingPatientModalController',
                                    resolve: {
                                        isCreatingPatient: function () {
                                            return false;
                                        }
                                    }
                                });

                                dedupingModalInstance.result.then(function (useExistingPatient) {
                                    if (useExistingPatient) {
                                        ModalHandler.close($uibModalInstance, success.patient);
                                    } else {
                                        updatePatient();
                                    }
                                }).catch(function () {
                                    // Logger.log('Modal dismissed');
                                });
                            } else {
                                updatePatient();
                            }

                        });
                } else {
                    updatePatient();
                }

            };

            $scope.openDatePicker = function ($event) {
                $scope.datepickerStatus.opened = true;
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('ChangeDestProviderModalController', ['$scope', '$uibModalInstance', 'Alert', 'ModalHandler', 'Referral', 'referral', 'USER_ROLES',
        function ($scope, $uibModalInstance, Alert, ModalHandler, Referral, referral, USER_ROLES) {
            $scope.providerId = referral.dest_provider_id;
            $scope.referral = angular.copy(referral);

            $scope.referral.dest_practice.users.unshift({ id: -1, first_name: 'First', last_name: 'Available', firstAvailable: true, addresses: $scope.referral.dest_practice.addresses });
            $scope.doctorRoleMask = USER_ROLES.doctor.mask;

            $scope.filterByAddress = function (addressId) {
                return function (item) {
                    for (var i = 0; i < item.addresses.length; i++) {
                        if (item.addresses[i].id === addressId) {
                            return true;
                        }
                    }
                    return false;
                };
            };
            $scope.ok = function (providerId) {
                $scope.referral.dest_practice.users.shift();
                referral = $scope.referral;
                Referral.update({ id: referral.id }, { referral: { dest_provider_id: providerId, address_id: $scope.referral.address_id } },
                    function (success) {
                        ModalHandler.close($uibModalInstance, providerId);
                    },
                    function (failure) {
                        Alert.error($scope.alerts, 'Error occurred during referral update.');
                    });
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('NoteModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'Referral', 'referral', 'allowGenerate',
        function ($scope, $uibModalInstance, ModalHandler, Referral, referral, allowGenerate) {
            $scope.drafts = [];
            $scope.allowGenerate = allowGenerate;

            $scope.ok = function (note) {
                //nothing to do, we cant save note right here because at this stage referral doesn't exist. We can only add new note to the list on the parent page (create referral) and save simultaneously with referral.
                if (note == undefined || note.match(/^\s*$/)) {
                    ModalHandler.dismiss($uibModalInstance);
                } else {
                    ModalHandler.close($uibModalInstance, note);
                }

            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };

            $scope.generateDrafts = function () {
                Referral.getNoteDrafts({id: referral.id}).$promise
                    .then(function (drafts) {
                        $scope.drafts = drafts;

                        if ($scope.drafts.length > 0) {
                            $scope.insertDraft($scope.drafts[0]);
                        }
                    })
                    .catch(function (error) {
                    });
            };

            $scope.insertDraft = function(draft) {
                $scope.note = draft.note;
                var textarea = document.getElementById('note');
                textarea.focus();
            };
        }])

    .controller('EditNoteModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'noteData',
        function ($scope, $uibModalInstance, ModalHandler, noteData) {
            $scope.note = angular.copy(noteData);

            $scope.ok = function (note) {
                if (note == undefined || note.message.match(/^\s*$/)) {
                    ModalHandler.dismiss($uibModalInstance);
                } else {
                    ModalHandler.close($uibModalInstance, $scope.note);
                }
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };

        }])
    .controller('NoteVersionsModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'versions',
        function ($scope, $uibModalInstance, ModalHandler, versions) {
            $scope.versions = versions;
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };

        }])

    .controller('ProviderModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'ProviderInvitation', 'Alert', 'BadEmailNotice', 'dependsOnReferral', 'inviterId',
        function ($scope, $uibModalInstance, ModalHandler, ProviderInvitation, Alert, BadEmailNotice, dependsOnReferral, inviterId) {
            // dependsOnReferral - is true when this dialog is opened from create_referral page

            $scope.alerts = [];
            $scope.model = {};
            $scope.isProviderInvite = true;
            $scope.suggest_practice = null;

            $scope.$watch( //we need only one-way updates from typeahead, otherwise typeahead works incorrectly
                function () {
                    return $scope.model.existingProvider;
                }, function (newVal, oldVal, scope) {
                    if (newVal) {
                        $scope.model.provider = { id: newVal.id, first_name: newVal.first_name, email: newVal.email, last_name: newVal.last_name };
                    }
                });
            $scope.ok = function (provider) {
                provider.inviter_id = inviterId;
                $scope.suggest_practice = null; // reset

                ProviderInvitation.save(
                    {
                        provider_invitation: provider,
                        send_email: !dependsOnReferral,  // when false - invitation is still created, but email message is not sent here.
                        front_desk: !$scope.isProviderInvite
                    },
                    function (provider) {
                        ModalHandler.close($uibModalInstance, { provider: provider });
                    },
                    function (failure) {
                        $scope.alerts = [];
                        var data = failure.data;
                        if (BadEmailNotice.isRejection(data)) {
                            BadEmailNotice.notify(data);
                            return;
                        }
                        // DCL-662: a network error or 5xx has no JSON body to read
                        data = data || {};
                        var practice = data.suggest_practice;
                        if (data.errors) {
                            data = data.errors;
                        }
                        var message = data.message && data.message[0];

                        if (message == 'user.exists' && practice) {
                            if (dependsOnReferral) {
                                $scope.suggest_practice = practice;
                            } else {
                                // When opened from Admin->Colleagues, no need to select existing invitation for anytihng, as of now.
                                Alert.error($scope.alerts, 'colleague.exists', true);
                            }
                        } else {
                            Alert.error($scope.alerts, message || 'default.error', true);
                        }
                    });
            };
            $scope.reset_suggest_practice = function () {
                $scope.suggest_practice = null;
            };
            $scope.selectExistingPractice = function (practice) {
                ModalHandler.close($uibModalInstance, { practice: practice });
            };
            $scope.closeAlert = function (index) {
                Alert.close($scope.alerts, index);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('PracticeDeleteModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'Practice', 'User', 'Referral', 'selectedPractice', 'Notification',
        function ($scope, $uibModalInstance, ModalHandler, Practice, User, Referral, selectedPractice, Notification) {
            $scope.practice = angular.copy(selectedPractice);
            // DCL-572: one mutually exclusive choice — delete everything,
            // re-assign referrals to a provider elsewhere, or move the users
            // into another practice with their referrals following them.
            $scope.delete_mode = 'delete_all';
            $scope.dest_practice = {};
            // null (not '') so the select shows its placeholder option instead
            // of an angular-generated blank "unknown" option.
            $scope.dest_user = null;
            $scope.users_dest_practice = {};
            // DCL-582: the dialog is the only confirmation step, so the action
            // button stays disabled until the risk is acknowledged. This used to
            // be a retype-the-practice-name field, which blocked every mode
            // without ever saying so on screen.
            $scope.confirmed = false;

            // Every mode ends with the practice record gone, but calling all
            // three "Delete" made a merge read as a destructive delete. The
            // button names the outcome the chosen mode actually produces.
            $scope.actionLabel = function () {
                if ($scope.delete_mode == 'move_referrals') { return 'Reassign & Delete'; }
                if ($scope.delete_mode == 'move_users') { return 'Merge'; }
                return 'Delete';
            };

            Referral.countByPractice({ id: $scope.practice.id },
                function (success) {
                    $scope.referrals_count = success.count;
                });

            User.getAllUsers({ practice_id: $scope.practice.id },
                function (users) {
                    $scope.users_count = users.length;
                });

            // excludes the practice being deleted from typeahead results
            var searchOtherPractices = function (searchValue) {
                return Practice.publicSearchPractice({ search: searchValue }).$promise
                    .then(function (practices) {
                        return practices.filter(function (p) {
                            return p.id != $scope.practice.id;
                        });
                    });
            };

            $scope.findPractice = function (searchValue) {
                // Editing the practice search invalidates the provider picked
                // for the previous practice along with the practice itself.
                $scope.dest_practice = {};
                $scope.dest_user = null;
                return searchOtherPractices(searchValue);
            };

            $scope.onPracticeSelected = function (destPractice) {
                $scope.dest_practice = destPractice;
                // Referral orig/dest providers are doctors, so only providers
                // are offered here — not every user of the practice.
                User.getOtherProviders({ practice_id: destPractice.id },
                    function (users) {
                        $scope.dest_practice.users = users;
                    });
            };

            $scope.findUsersPractice = function (searchValue) {
                $scope.users_dest_practice = {};
                return searchOtherPractices(searchValue);
            };

            $scope.onUsersPracticeSelected = function (destPractice) {
                $scope.users_dest_practice = destPractice;
            };

            $scope.deletePractice = function () {
                // The dialog closes only once the backend confirmed the delete;
                // on failure it stays open so the choice can be corrected.
                var onSuccess = function () {
                    Notification.success('Practice delete success');
                    ModalHandler.close($uibModalInstance);
                };
                var onFailure = function (failure) {
                    Notification.error(failure.data && failure.data.message ? failure.data.message : 'Practice delete fail');
                };
                if ($scope.delete_mode == 'move_referrals') {
                    Practice.deleteAndMoveReferral({ id: $scope.practice.id, dest_practice_id: $scope.dest_practice.id, dest_user_id: $scope.dest_user.id },
                        onSuccess, onFailure);
                } else {
                    // With users_dest_practice_id the backend moves the users AND
                    // their referrals (providers untouched); without it, plain delete.
                    var usersDestPracticeId = $scope.delete_mode == 'move_users' ? $scope.users_dest_practice.id : undefined;
                    Practice.delete({ practiceId: $scope.practice.id, users_dest_practice_id: usersDestPracticeId },
                        onSuccess, onFailure);
                }
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    // Controller for New User dialog, view is: user_form.html
    .controller('UserModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'ProviderInvitation', 'Registration', 'Auth', 'Alert', 'BadEmailNotice', 'Logger', 'USER_ROLES', 'Role', 'practice', 'practiceTypes', '$rootScope', 'AUTH_EVENTS',
        function ($scope, $uibModalInstance, ModalHandler, ProviderInvitation, Registration, Auth, Alert, BadEmailNotice, Logger, USER_ROLES, Role, practice, practiceTypes, $rootScope, AUTH_EVENTS) {
            $scope.practice = angular.copy(practice);
            $scope.practiceTypes = practiceTypes.filter(function (type) {
                return type.code != 'multi_specialty';
            });
            $scope.result = {};
            $scope.alerts = [];
            $scope.isInvite = true;
            $scope.isAux = false;
            $scope.user = {};
            $scope.user.roles_mask = 0;
            $scope.user.specialty_type_id = $scope.practice.practice_type.code != 'multi_specialty' ? $scope.practice.practice_type_id : '';
            $scope.defaultRoles = [USER_ROLES.aux];
            $scope.showRoles = [USER_ROLES.aux, USER_ROLES.doctor, USER_ROLES.admin];

            // DCL-558/566: a Basic practice is capped at one provider (doctor),
            // counted as active doctor users only. plan_limits rides on the
            // practice payload (PracticesController#show); a null limit means
            // Premium. Invitations are never blocked — the invitee is stopped at
            // registration — so this only disables "No-login", which creates a
            // provider on the spot, and drives the explanatory notice.
            var providerLimits = ($scope.practice.plan_limits && $scope.practice.plan_limits.providers) || null;
            $scope.atProviderLimit = !!(providerLimits && providerLimits.limit && !providerLimits.can_add);

            // Reuses the shared upgrade modal via the event the global 402 handler
            // listens to (same as historyController).
            $scope.openUpgradeModal = function () {
                $rootScope.$broadcast(AUTH_EVENTS.paymentRequired, {feature: 'providers', source: 'providers'});
            };

            $scope.toggleRadio = function () {
                if (!$scope.isInvite) {
                    $scope.defaultRoles = [USER_ROLES.doctor];
                    $scope.showRoles = [USER_ROLES.doctor];
                } else {
                    $scope.defaultRoles = [USER_ROLES.aux];
                    $scope.showRoles = [USER_ROLES.doctor, USER_ROLES.aux, USER_ROLES.admin];
                }
            };

            $scope.onRoleChange = function (resultMask) {
                var roles = Role.getFromMask(resultMask);
                $scope.isAux = Role.hasRoles([USER_ROLES.aux], roles);
                $scope.isDoctor = Role.hasRoles([USER_ROLES.doctor], roles);
            };

            // DCL-662: the first `errors.message`, or the generic error when the
            // body has none (a network error or 5xx has no JSON body at all)
            function failureMessage(failure) {
                var errors = failure && failure.data && failure.data.errors;
                return (errors && errors.message && errors.message[0]) || 'default.error';
            }

            $scope.ok = function (user) {
                user.practice_id = ($scope.params && $scope.params.practiceId) || Auth.getOrRedirect().practice_id;
                user.inviter_id = Auth.getOrRedirect().id;

                if ($scope.isAux) {
                    user.specialty_type_id = '';
                }

                if ($scope.isInvite) {
                    // User invitation case - invitation is created and email message is sent out
                    ProviderInvitation.save({ provider_invitation: user },
                        function (invitation) {
                            ModalHandler.close($uibModalInstance, invitation);
                        }, function (failure) {
                            $scope.alerts = []; //reset alerts list because we need only one alert at a time
                            // DCL-649: this body has no `errors`, so it used to throw here
                            // instead of reporting anything
                            if (BadEmailNotice.isRejection(failure.data)) {
                                BadEmailNotice.notify(failure.data);
                                return;
                            }
                            Alert.error($scope.alerts, failureMessage(failure), true);
                        });
                } else {
                    // User without email address and ability to login - we create user immediately without sending email for ownership confirmation
                    Registration.create_no_login_user({ user: user },
                        function (user) {
                            ModalHandler.close($uibModalInstance, user);
                        }, function (failure) {
                            $scope.alerts = []; //reset alerts list because we need only one alert at a time
                            Alert.error($scope.alerts, failureMessage(failure), true);
                        });
                }
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('EditUserModalController', ['$scope', 'nameEditable', '$uibModalInstance', 'ModalHandler', 'User', 'Auth', 'Logger', 'editUser', 'practiceType', 'practiceAddresses', 'USER_ROLES', 'Role', 'Procedure', '$uibModal', 'UserEmailSuppression', 'EmailSuppressionWarning', 'Notification',
        function ($scope, nameEditable, $uibModalInstance, ModalHandler, User, Auth, Logger, editUser, practiceType, practiceAddresses, USER_ROLES, Role, Procedure, $uibModal, UserEmailSuppression, EmailSuppressionWarning, Notification) {
            $scope.result = {};
            $scope.alerts = [];
            $scope.nameEditable = nameEditable;
            $scope.practiceTypes = [];
            $scope.showRoles = [USER_ROLES.super, USER_ROLES.aux, USER_ROLES.doctor, USER_ROLES.admin];
            Procedure.practiceTypes({ 'include_procedures': false },
                function (success) {
                    success.map(function (item) {
                        if (item.code !== 'multi_specialty') {
                            $scope.practiceTypes.push(item);
                        }
                    });
                });
            $scope.user = editUser;
            $scope.hasLogin = !!editUser.email;
            $scope.practiceAddresses = practiceAddresses;
            $scope.user.is_admin = Role.hasRoles([USER_ROLES.admin], Role.getFromMask($scope.user.roles_mask));
            var initialEmail = editUser.email;

            $scope.auth = Auth.get();
            $scope.isSelf = $scope.auth && $scope.auth.id === editUser.id;

            // DCL-462: banner when the provider has suppressed this user's email.
            // Shown regardless of notification preference — transactional mail
            // (password resets etc.) is blocked too.
            $scope.emailSuppression = null;
            if ($scope.hasLogin) {
                UserEmailSuppression.get({id: editUser.id}, function (data) {
                    $scope.emailSuppression = data.suppressed ? data : null;
                }, angular.noop); // a failed check must never break the dialog
            }

            $scope.openSuppressionDetails = function () {
                EmailSuppressionWarning.openDetailsDialog(editUser.id, $scope.emailSuppression, function () {
                    $scope.emailSuppression = null;
                });
            };

            $scope.saveIsAdmin = function (user) {
                var requested = user.is_admin;
                User.updateIsAdmin({ id: user.id }, requested ? 'true' : 'false').$promise
                    .then(function (success) {
                    })
                    .catch(function (failure) {
                        // DCL-571: the server refuses to demote a practice's last
                        // admin (422). The checkbox has already flipped, so flip
                        // it back and say why.
                        user.is_admin = !requested;
                        Notification.error((failure.data && failure.data.message) ||
                            'The change could not be saved. Please try again or contact support.');
                        Logger.error('ERROR: ' + JSON.stringify(failure));
                    });
            };

            $scope.saveSpecialty = function(user) {
                User.updateSpecialty({ id: user.id }, { specialty_type_id: user.specialty_type_id }).$promise
                    .then(function (success) {
                    })
                    .catch(function (failure) {
                        Logger.error('ERROR: ' + JSON.stringify(failure));
                    });
            };

            $scope.saveNotificationPreference = function (user) {
                User.updateNotificationPreference({ id: user.id }, { notification_preference: user.notification_preference }).$promise
                    .then(function (success) {
                    })
                    .catch(function (failure) {
                        Logger.error('ERROR: ' + JSON.stringify(failure));
                    });
            };

            $scope.roleName = function (roles_mask) {
                var str = '';
                Role.getFromMask(roles_mask).reverse().forEach(function (elem) {
                    str += str == '' ? elem.name : ', ' + elem.name;
                });
                return str;
            };

            $scope.is_multispecialty = function () {
                return Role.hasRoles([USER_ROLES.doctor], Role.getFromMask($scope.user.roles_mask)) && practiceType.code === 'multi_specialty';
            };

            $scope.changeNameModal = function(user) {
                if (!$scope.nameEditable) {
                    return;
                }
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/change_name_modal.html',
                    controller: 'ChangeNameModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (updatedUser) {
                    // Update the user object in the parent scope if needed
                    $scope.user.first_name = updatedUser.first_name;
                    $scope.user.last_name = updatedUser.last_name;
                }).catch(function() {
                    // Logger.log('Change Name modal dismissed');
                });
            };

            $scope.changeEmailModal = function(user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/change_email_modal.html',
                    controller: 'ChangeEmailModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (email) {
                }).catch(function() {
                    // Logger.log('Modal dismissed');
                });
            };

            $scope.changePasswordModal = function(user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/reset_password_modal.html',
                    controller: 'ResetPasswordModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (email) {
                }).catch(function() {
                    // Logger.log('Modal dismissed');
                });
            };

            $scope.createLoginModal = function (user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/create_login_modal.html',
                    controller: 'CreateLoginModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (email) {
                    $uibModalInstance.dismiss('done');
                }).catch(function() {
                    // Logger.log('Modal dismissed');
                });
            };

            $scope.done = function () {
                $uibModalInstance.dismiss('done');
            };
        }])

    // DCL-462: details of a provider email suppression + removal action.
    // Opened from the history-page toast and the Edit User dialog banner.
    .controller('EmailSuppressionDetailsModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'UserEmailSuppression', 'Notification', 'userId', 'suppression',
        function ($scope, $uibModalInstance, ModalHandler, UserEmailSuppression, Notification, userId, suppression) {
            $scope.suppression = suppression;
            $scope.isSpamComplaint = suppression.suppression_type === 'spam complaint';
            // DCL-482: suppressions are scoped to the provider's sending stream.
            // Bulk-only rows block marketing mail, not DCL notifications, and the
            // dialog copy differs accordingly.
            $scope.isBulkOnly = suppression.sending_stream === 'bulk';
            $scope.streamLabel = {
                transactional: 'Transactional notifications',
                bulk: 'Promotional messages',
                any: 'All messages'
            }[suppression.sending_stream] || null;
            $scope.removing = false;
            $scope.removeError = null;

            $scope.remove = function () {
                $scope.removing = true;
                $scope.removeError = null;
                UserEmailSuppression.remove({id: userId}, function () {
                    $scope.removing = false;
                    // The dialog closes right after this, so the toast is the only
                    // confirmation left on screen. It renders through dynamic-html,
                    // which shows a plain string as text (DCL-702).
                    Notification.success('Email delivery to this address has been resumed.');
                    ModalHandler.close($uibModalInstance, 'removed');
                }, function (failure) {
                    $scope.removing = false;
                    $scope.removeError = (failure.data && failure.data.message) ||
                        'The suppression could not be removed. Please try again or contact support.';
                });
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('ChangeNameModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'User', 'Alert', 'Logger', 'user',
        function ($scope, $uibModalInstance, ModalHandler, User, Alert, Logger, user) {
            $scope.user = angular.copy(user); // Use a copy to allow discarding changes
            $scope.alerts = [];

            $scope.ok = function (updatedUser) {
                User.updateName({ id: user.id }, { user: { first_name: updatedUser.first_name, last_name: updatedUser.last_name } }).$promise
                    .then(function (success) {
                        Alert.success($scope.alerts, 'User name updated successfully.', true);
                        // Pass the updated user back
                        ModalHandler.close($uibModalInstance, success); 
                    })
                    .catch(function (failure) {
                        $scope.alerts = [];
                        var message = (failure.data && failure.data.error) || 'An error occurred while updating the user name.';
                        Alert.error($scope.alerts, message, true);
                    });
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('DatePickerModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'currentDate',
        function ($scope, $uibModalInstance, ModalHandler, currentDate) {
            $scope.date = currentDate;

            $scope.dateSelected = function () {
                ModalHandler.close($uibModalInstance, $scope.date);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('RegistrationResultController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.resultMessage = 'Thank you for registering your account on Dental Care Links. Your account is ready to start sending HIPAA Compliant referrals!';
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('PendingReviewRegistrationResultController', ['$scope', '$uibModalInstance', 'ModalHandler', '$sce',
        function ($scope, $uibModalInstance, ModalHandler, $sce) {
            $scope.resultMessage = $sce.trustAsHtml('Thank you for registering your account on Dental Care Links.<br>' +
                'In order to ensure the highest level of security and quality of service, new accounts must be reviewed prior to being activated.<br>' +
                'This usually takes less than 24 hours.<br>' +
                'We will notify you as soon as your account is active. Thank you for your patience!');
    
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('InviteUserResultController', ['$scope', '$uibModalInstance', 'ModalHandler', 'noLogin', 'toEmail', 'waitingForProviderSlot',
        function ($scope, $uibModalInstance, ModalHandler, noLogin, toEmail, waitingForProviderSlot) {
            if (noLogin) {
                $scope.modalHeader = 'User created successfully';
                $scope.resultMessage = "A new user has been created and is now listed as a provider in your practice. This user was created without login credentials. If you would like this user to be able to login to your account please edit their settings to add an email address.";
            } else {
                $scope.modalHeader = 'User invitation successful';
                $scope.resultMessage = 'Your invitation has been sent to ' + toEmail + '. The email message contains a special link to complete their registration, once this is done their account will be activated.';
            }

            // DCL-566: the invitation is real and stays open; it simply cannot be
            // accepted until the practice has room for another provider.
            $scope.caveat = waitingForProviderSlot
                ? "This practice is at its Basic-plan provider limit, so they can't finish registering until a provider slot is free or the practice upgrades."
                : '';

            $scope.ok = function() {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('InvitePracticeResultController', ['$scope', '$uibModalInstance', 'ModalHandler', 'toEmail',
        function ($scope, $uibModalInstance, ModalHandler, toEmail) {
            $scope.resultMessage = 'Your invitation has been sent to ' + toEmail + '. The email message contains a special link to complete their practice registration.';
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('EmailChangeResultController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.resultMessage = 'Your email was changed. Please login with your new credentials';
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('ReferralSuccessModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'destinationNameFilter', 'referral',
        function ($scope, $uibModalInstance, ModalHandler, destinationNameFilter, referral) {
            $scope.destinationLabel = destinationNameFilter(referral);
            $scope.cancel = function () {
                ModalHandler.close($uibModalInstance);
            };
            $scope.goDownload = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('InvitationValidationController', ['$scope', '$uibModalInstance', 'Alert', 'ModalHandler', 'ProviderInvitation', 'invitation',
        function ($scope, $uibModalInstance, Alert, ModalHandler, ProviderInvitation, invitation) {
            $scope.alerts = [];
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
            $scope.sendInvitation = function () {
                ProviderInvitation.resend({ id: invitation.id },
                    function (success) {
                        ModalHandler.close($uibModalInstance);
                    },
                    function (failure) {
                        $scope.alerts = [];
                        Alert.error($scope.alerts, 'An error occurred during invitation resend...', true)
                    });
            }
        }])

    .controller('ErrorModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'message',
        function ($scope, $uibModalInstance, ModalHandler, message) {
            $scope.message = message;

            $scope.cancel = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    // View is confirm_dialog.html; opened through the ConfirmDialog service.
    .controller('ConfirmDialogController', ['$scope', '$uibModalInstance', 'ModalHandler', 'options',
        function ($scope, $uibModalInstance, ModalHandler, options) {
            $scope.title = options.title;
            $scope.message = options.message;
            $scope.warning = options.warning;
            $scope.confirmText = options.confirmText;
            $scope.cancelText = options.cancelText;
            $scope.confirm = function () {
                ModalHandler.close($uibModalInstance);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('UnsubscribeModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'confirmMessage',
        function ($scope, $uibModalInstance, ModalHandler, confirmMessage) {
            $scope.confirmMessage = confirmMessage;

            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    .controller('PostOpReminderModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'referral',
        function ($scope, $uibModalInstance, ModalHandler, referral) {
            function providerDisplayName(provider) {
                if (!provider) {
                    return 'the originating provider';
                }

                var name = [];
                if (provider.first_name) {
                    name.push(provider.first_name);
                }
                if (provider.last_name) {
                    name.push(provider.last_name);
                }

                if (name.length) {
                    return 'Dr. ' + name.join(' ');
                }

                if (provider.practice && provider.practice.name) {
                    return provider.practice.name;
                }

                return provider.email || 'the originating provider';
            }

            $scope.providerDisplayName = providerDisplayName(referral && referral.orig_provider);

            $scope.dismiss = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    .controller('SuccessGuestReferralModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.message = "Almost done! We need you to confirm the entered email is yours. Please activate the referral by clicking the link in the email message we've sent to you.";

            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    .controller('RegistrationEmailResendModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.ok = function () {
                ModalHandler.dismiss($uibModalInstance);
            }

        }])

    .controller('AddPluginVersionModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.version = '';
            $scope.add = function () {
                ModalHandler.close($uibModalInstance, $scope.version);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('VersionLogsModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'logs',
        function ($scope, $uibModalInstance, ModalHandler, logs) {
            $scope.logs = logs;

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('InviteGuestModalController', ['$scope', '$modalInstance', 'ModalHandler', 'Referral', 'referral', 'Notification',
        function ($scope, $modalInstance, ModalHandler, Referral, referral, Notification) {

            $scope.invite = function () {
                Referral.sendGuestReferralUpdatedEmail({ id: referral.id },
                    function (success) {
                        Notification.success('Email to guest was sent successfully!');
                        referral.no_more_guest_conversion_offers = true; // no more than one offer email per referral. Server also sets it to true
                        ModalHandler.dismiss($modalInstance);
                    }, function (error) {
                        Notification.error('An error occurred.');
                        ModalHandler.dismiss($modalInstance);
                    });
            };

            $scope.skip = function () {
                ModalHandler.dismiss($modalInstance);
            };
        }])

    .controller('ReverseReferralWarningModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'existingReferral',
        function ($scope, $uibModalInstance, ModalHandler, existingReferral) {
            $scope.existingReferral = existingReferral;
            $scope.choice = 'view_existing'; // default choice

            $scope.ok = function () {
                ModalHandler.close($uibModalInstance, $scope.choice);
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }]);
